export enum StoryboardStep {
  Script = 0,
  SceneElements = 1,
  ShotList = 2,
  Storyboard = 3,
}

export enum StoryboardStepStatus {
  Saving,
  Generating,
  Ready,
  Failed,
  Disabled,
}
